class CoInsured {

    $container;
    $rows;

    constructor() {
        $(document).on('click', '[data-action^="co-insured"]', this.clickHandler.bind(this));
        this.$container = $('.co-insured-items');
        this.$rows = $('.co-insured');
    }

    clickHandler(e) {
        const target = e.currentTarget;
        const $target = $(target);
        const action = $target.data('action').split('co-insured:').pop();

        switch (action) {
            case 'add':
                this.addChildRow();
                break;

            case 'remove':
                this.removeChildRow($target.parent().parent());
                break;
        }
    }

    addChildRow() {
        return new Promise(resolve => {
            $.ajax({
                url: '/api/co-insured-child.html',
                data: {
                    uuid: this.generateUuid(),
                },
                success: response => {
                    this.$container.append(response);
                    this.$container.find('[data-action="co-insured:remove"]').show();
                    this.$rows = $('.co-insured');

                    const collapse = new Collapse();
                    collapse.registerChangeHandlers();

                    resolve(response);
                },
                error: () => {
                    resolve(false);
                }
            });
        });
    }

    removeChildRow($target) {
        if (this.$rows.length === 1) {
            return;
        }

        $target.remove();
        this.$rows = $('.co-insured');
        if (this.$rows.length === 1) {
            this.$container.find('[data-action="co-insured:remove"]').hide();
        }
    }

    generateUuid(length = 12) {
        const chars = '0123456789ABCDEF';
        let out = '';
        for (let i = 0; i < length; i++) {
            out += chars.substr(Math.floor(Math.random() * chars.length), 1);
        }

        return out;
    }
}
